let dims = {};

// Initial window dimensions
dims.w = window.innerWidth || document.documentElement.clientWidth;
dims.h = window.innerHeight || document.documentElement.clientHeight;

// Function to update window dimensions
function updateWindowDimensions() {
	dims.w = window.innerWidth || document.documentElement.clientWidth;
    dims.h = window.innerHeight || document.documentElement.clientHeight;
}

module.exports = dims;